import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/store";

type formState = {
  page: number;
  isLoading: boolean;
};

const initialState: formState = {
  page: 0,
  isLoading: false,
};

const formStateSlice = createSlice({
  name: "formState",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    increamentPage: (state) => {
      state.page += 1;
    },
    decrementPage: (state) => {
      state.page -= 1;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    resetFormState: () => initialState,
  },
});

export const {
  setPage,
  increamentPage,
  decrementPage,
  setIsLoading,
  resetFormState,
} = formStateSlice.actions;

export const selectPage = (state: RootState) => state.formState.page;
export const selectIsLoading = (state: RootState) => state.formState.isLoading;

export const formStateReducer = formStateSlice.reducer;
